// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.survey-container {
    font-family: Roboto;
    box-shadow: 0px 0px 21.9px 0px rgba(106, 106, 106, 0.39);
    color: #000000;
    padding: 1rem 1rem;
    background-color: #FFFFFF;
    width: 500px;
    height: fit-content;
    right: 20px;
	position: absolute;
	margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    visibility: hidden;
    transition:
        background-color 0.2s,
        fill 0.2s,
        opacity 0.5s;
    opacity: 0;
    text-align: left;
    border-radius: 10px;
    z-index: 1000000;
}
.survey-header .close-btn {
    cursor: pointer;
    margin-left: auto;
    margin-bottom: 5px;
    width: 15px;
    height: 15px;
    color: var(--Semantic-Background-Tertiary, rgba(177, 186, 190, 1));
}
.survey-level-text {
    margin-top: 30px;
}
.survey-option {
    display: flex;
    flex-direction: column;
    width: 60px;
    height: 80px;
    margin: auto 0;
}
.survey-option.selected .emotion-rating {
    fill: #FFFFFF;
    background-color: rgba(57, 174, 223, 1);
}
.survey-header {
    padding: 5px 0px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid var(--Semantic-Extensions-Border-Table, rgba(208, 213, 215, 1));
}
.survey-container.active {
    visibility: visible;
    opacity: 1;
}
.selected .satisfaction-text {
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
    color: rgba(57, 174, 223, 1);
    display: block;
}
.satisfaction-text {
    display: none;
}
.survey-level-options {
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
@media (max-width: 480px) {
.survey-title-text.survey-title-text {
        font-size: 14px;
}
.survey-container {
        font-size: 12px;
        max-width: 90vw;
}
.selected .satisfaction-text {
        font-size: 12px;
}
}
.survey-content-container {
    padding-right: 10px;
    max-height: 60vh;
    overflow-y: auto;
    color: rgba(95, 107, 113, 1);
}
.survey-level-container {
    display: flex;
    flex-direction: column;
    overflow-y: visible;
    margin-top: 5px;
    margin-bottom: 10px;
    padding-bottom: 5px;
}
.survey-input-title {
    margin: 10px 0px;
}
.survey-input-text {
    width: 100%;
    height: 150px;
    resize: none;
}
.survey-input-text:focus-visible {
    outline: rgba(57, 174, 223, 1) auto 1px;
}
.survey-title-text {
    color: rgba(95, 107, 113, 1);
    font-size: 18px;
    display: block;
    width: 100%;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transform: translateY(5px);
    padding: 16px, 0px, 10px, 0px;
}
.survey-footer {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
}
.survey-submit-btn {
    margin-left: auto;
}
.survey-btn {
    transition:
        background-color 0.2s,
        fill 0.2s,
        opacity 0.5s;
    cursor: pointer;
    width: 80px;
    height: 30px;
    color: rgba(141, 153, 160, 1);
    padding: 7px, 5px;
    font-size: 12px;
    border: 1px solid var(--Semantic-Border-Light, rgba(177, 186, 190, 1));
    border-radius: 5px;
    background-color: #FFFFFF;
}
.survey-btn-loading::after {
    animation: loading .5s infinite linear;
    animation-duration: 0.5s;
    animation-timing-function: linear;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
    animation-name: loading;
    animation-timeline: auto;
    animation-range-start: normal;
    animation-range-end: normal;
    border: .1rem solid var(--Semantic-Border-Light, rgba(177, 186, 190, 1));
    border-radius: 50%;
    border-right-color: transparent;
    border-top-color: transparent;
    content: "";
    display: block;
    height: .8rem;
    margin-left: -.4rem;
    margin-top: -.4rem;
    position: absolute;
    top: 50%;
    left: 50%;
    width: .8rem;
    z-index: 1;
}
.survey-submit-btn:hover {
    color: #FFFFFF;
    border-color: #FFFFFF;
    background-color: rgba(57, 174, 223, 1);
}
.survey-cancel-btn {
    width: 90px;
}
.survey-cancel-btn:hover {
    color: #FFFFFF;
    background: #bbbdbf;
    border-color: #bbbdbf;
}
.survey-btn-loading.survey-btn-loading {
    color: transparent;
    min-height: .8rem;
    pointer-events: none;
    position: relative;
}
.emotion-rating {
    transition:
        background-color 0.2s,
        fill 0.2s,
        opacity 0.5s;
    cursor: pointer;
    border-radius: 15px;
    background-color: rgba(233, 235, 236, 1);
    fill: rgba(18, 84, 113, 1);
    width: 60px;
    height: 60px;
    padding: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/vue/CustomerSurveyModal.vue"],"names":[],"mappings":";AA4IA;IACI,mBAAmB;IACnB,wDAAwD;IACxD,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,WAAW;CACd,kBAAkB;CAClB,YAAY;IACT,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB;;;oBAGgB;IAChB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kEAAkE;AACtE;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AAEA;IACI,aAAa;IACb,uCAAuC;AAC3C;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,wFAAwF;AAC5F;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,cAAc;AAClB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AAEA;AACI;QACI,eAAe;AACnB;AACA;QACI,eAAe;QACf,eAAe;AACnB;AACA;QACI,eAAe;AACnB;AACJ;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;AAEA;IACI,uCAAuC;AAC3C;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,cAAc;IACd,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;AACjC;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AAEA;IACI,iBAAiB;AACrB;AAEA;IACI;;;oBAGgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,sEAAsE;IACtE,kBAAkB;IAClB,yBAAyB;AAC7B;AAEA;IACI,sCAAsC;IACtC,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;IACnB,mCAAmC;IACnC,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,2BAA2B;IAC3B,wEAAwE;IACxE,kBAAkB;IAClB,+BAA+B;IAC/B,6BAA6B;IAC7B,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,UAAU;AACd;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,uCAAuC;AAC3C;AAEA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;AAGA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;AAEA;IACI;;;oBAGgB;IAChB,eAAe;IACf,mBAAmB;IACnB,wCAAwC;IACxC,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,YAAY;AAChB","sourcesContent":["<script>\nimport SurveyAverage from \"./icons/SurveyAverage.vue\"\nimport SurveyGood from \"./icons/SurveyGood.vue\"\nimport SurveyBad from \"./icons/SurveyBad.vue\"\nimport SurveyVeryBad from \"./icons/SurveyVeryBad.vue\"\nimport SurveyVeryGood from \"./icons/SurveyVeryGood.vue\"\n\nexport default {\n    props: {\n    },\n    data() {\n        return {\n            feedBackText: \"\",\n            isActive: true,\n            selectedLevel: 0,\n            isLoading: false,\n        }\n    },\n    computed: {\n        computedClass() {\n            return {\n                \"active\": this.isActive,\n            }\n        },\n        surveyButtonLoading() {\n            return {\n                \"survey-btn-loading\": this.isLoading,\n            }\n        }\n    },\n    methods: {\n        handleTextChange(e) {\n            this.feedBackText = e.target.value;\n        },\n        dismiss() {\n            const url = DashURL(\"satisfaction_survey\");\n            const data = {\n                dismiss: true,\n            }\n            fetch(url, {\n                method: \"POST\",\n                headers: {\n                    'Content-Type': 'application/x-www-form-urlencoded'\n                },\n                body: new URLSearchParams(data).toString(),\n            });\n            this.deactivate();\n        },\n        deactivate() {\n            this.isActive = false;\n        },\n        activate() { // Not used currently\n            this.isActive = true;\n        },\n        async postSurvey() {\n            if (this.isLoading) {\n                return;\n            }\n            if (!this.selectedLevel) {\n                alertModal.alert(\"満足度をお聞かせください。\");\n                return;\n            }\n            this.isLoading = true;\n            const url = DashURL(\"satisfaction_survey\");\n            const data = {\n                textInput: this.feedBackText,\n                satisfactionLevel: this.selectedLevel,\n            }\n\n            const res = await fetch(url, {\n                method: \"POST\",\n                headers: {\n                    'Content-Type': 'application/x-www-form-urlencoded'\n                },\n                body: new URLSearchParams(data).toString(),\n            });\n            const json = await res.json();\n            if (!res.ok || !json.success) {\n                alertModal.alert(\"送信に失敗しました、再度お試しください。\");\n                this.isLoading = false;\n                return;\n            }\n            this.deactivate();\n        },\n        selectLevel(n) {\n            this.selectedLevel = n;\n        },\n        isSelected(n) {\n            return {\n                \"selected\" : this.selectedLevel === n,\n            }\n        },\n    },\n    components: {\n        SurveyAverage,\n        SurveyVeryBad,\n        SurveyGood,\n        SurveyBad,\n        SurveyVeryGood,\n    },\n}\n</script>\n<template>\n    <div class=\"oplus-modal modal\" :class=\"computedClass\">\n        <div class=\"modal-overlay\" aria-label=\"Close\" @click=\"dismiss\"></div>\n        <div id=\"survey-container\" class=\"survey-container\" :class=\"computedClass\" @click=\"preventClose\">\n            <div class=\"survey-header\">\n                <b id=\"survey-title-text\" class=\"survey-title-text\">顧客満足度調査</b>\n                <span class=\"close-btn\" aria-label=\"Close\" @click=\"dismiss\">\n                    <i class=\"zmdi zmdi-close zmdi-hc-2x\"></i>\n                </span>\n\n            </div>\n            <div class=\"survey-content-container\">\n\n                <div id=\"survey-level-container\" class=\"survey-level-container\">\n                    <span class=\"survey-level-text\">どのくらいサービスに満足していますか？</span>\n                    <div class=\"survey-level-options\">\n                        <SurveyVeryBad class=\"survey-option\" :class=\"isSelected(1)\" @click=\"selectLevel(1)\" />\n                        <SurveyBad class=\"survey-option\" :class=\"isSelected(2)\" @click=\"selectLevel(2)\"/>\n                        <SurveyAverage class=\"survey-option\" :class=\"isSelected(3)\" @click=\"selectLevel(3)\"/>\n                        <SurveyGood class=\"survey-option\" :class=\"isSelected(4)\" @click=\"selectLevel(4)\"/>\n                        <SurveyVeryGood class=\"survey-option\" :class=\"isSelected(5)\" @click=\"selectLevel(5)\"/>\n                    </div>\n                </div>\n\n                <div id=\"survey-text-container\" class=\"survey-text-container\">\n                    <div class=\"survey-input-title\">ご意見をお聞かせください。</div>\n                    <textarea class=\"survey-input-text\" @change=\"handleTextChange\"></textarea>\n                </div>\n            </div>\n            <div class=\"survey-footer\">\n                <button class=\"survey-cancel-btn survey-btn oplus-modal-btn\" @click=\"dismiss\">キャンセル</button>\n                <button class=\"survey-submit-btn survey-btn oplus-modal-btn oplus-confirm-btn\" :class=\"surveyButtonLoading\" @click=\"postSurvey\">送信</button>\n            </div>\n        </div>\n    </div>\n</template>\n<style>\n\n.survey-container {\n    font-family: Roboto;\n    box-shadow: 0px 0px 21.9px 0px rgba(106, 106, 106, 0.39);\n    color: #000000;\n    padding: 1rem 1rem;\n    background-color: #FFFFFF;\n    width: 500px;\n    height: fit-content;\n    right: 20px;\n\tposition: absolute;\n\tmargin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    visibility: hidden;\n    transition:\n        background-color 0.2s,\n        fill 0.2s,\n        opacity 0.5s;\n    opacity: 0;\n    text-align: left;\n    border-radius: 10px;\n    z-index: 1000000;\n}\n\n.survey-header .close-btn {\n    cursor: pointer;\n    margin-left: auto;\n    margin-bottom: 5px;\n    width: 15px;\n    height: 15px;\n    color: var(--Semantic-Background-Tertiary, rgba(177, 186, 190, 1));\n}\n.survey-level-text {\n    margin-top: 30px;\n}\n.survey-option {\n    display: flex;\n    flex-direction: column;\n    width: 60px;\n    height: 80px;\n    margin: auto 0;\n}\n\n.survey-option.selected .emotion-rating {\n    fill: #FFFFFF;\n    background-color: rgba(57, 174, 223, 1);\n}\n\n.survey-header {\n    padding: 5px 0px;\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid var(--Semantic-Extensions-Border-Table, rgba(208, 213, 215, 1));\n}\n\n.survey-container.active {\n    visibility: visible;\n    opacity: 1;\n}\n\n.selected .satisfaction-text {\n    text-align: center;\n    white-space: nowrap;\n    font-size: 14px;\n    color: rgba(57, 174, 223, 1);\n    display: block;\n}\n\n.satisfaction-text {\n    display: none;\n}\n\n.survey-level-options {\n    height: 100px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n@media (max-width: 480px) {\n    .survey-title-text.survey-title-text {\n        font-size: 14px;\n    }\n    .survey-container {\n        font-size: 12px;\n        max-width: 90vw;\n    }\n    .selected .satisfaction-text {\n        font-size: 12px;\n    }\n}\n\n.survey-content-container {\n    padding-right: 10px;\n    max-height: 60vh;\n    overflow-y: auto;\n    color: rgba(95, 107, 113, 1);\n}\n\n.survey-level-container {\n    display: flex;\n    flex-direction: column;\n    overflow-y: visible;\n    margin-top: 5px;\n    margin-bottom: 10px;\n    padding-bottom: 5px;\n}\n\n.survey-input-title {\n    margin: 10px 0px;\n}\n\n.survey-input-text {\n    width: 100%;\n    height: 150px;\n    resize: none;\n}\n\n.survey-input-text:focus-visible {\n    outline: rgba(57, 174, 223, 1) auto 1px;\n}\n\n.survey-title-text {\n    color: rgba(95, 107, 113, 1);\n    font-size: 18px;\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transform: translateY(5px);\n    padding: 16px, 0px, 10px, 0px;\n}\n\n.survey-footer {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: row;\n}\n\n.survey-submit-btn {\n    margin-left: auto;\n}\n\n.survey-btn {\n    transition:\n        background-color 0.2s,\n        fill 0.2s,\n        opacity 0.5s;\n    cursor: pointer;\n    width: 80px;\n    height: 30px;\n    color: rgba(141, 153, 160, 1);\n    padding: 7px, 5px;\n    font-size: 12px;\n    border: 1px solid var(--Semantic-Border-Light, rgba(177, 186, 190, 1));\n    border-radius: 5px;\n    background-color: #FFFFFF;\n}\n\n.survey-btn-loading::after {\n    animation: loading .5s infinite linear;\n    animation-duration: 0.5s;\n    animation-timing-function: linear;\n    animation-delay: 0s;\n    animation-iteration-count: infinite;\n    animation-direction: normal;\n    animation-fill-mode: none;\n    animation-play-state: running;\n    animation-name: loading;\n    animation-timeline: auto;\n    animation-range-start: normal;\n    animation-range-end: normal;\n    border: .1rem solid var(--Semantic-Border-Light, rgba(177, 186, 190, 1));\n    border-radius: 50%;\n    border-right-color: transparent;\n    border-top-color: transparent;\n    content: \"\";\n    display: block;\n    height: .8rem;\n    margin-left: -.4rem;\n    margin-top: -.4rem;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: .8rem;\n    z-index: 1;\n}\n\n.survey-submit-btn:hover {\n    color: #FFFFFF;\n    border-color: #FFFFFF;\n    background-color: rgba(57, 174, 223, 1);\n}\n\n.survey-cancel-btn {\n    width: 90px;\n}\n.survey-cancel-btn:hover {\n    color: #FFFFFF;\n    background: #bbbdbf;\n    border-color: #bbbdbf;\n}\n\n\n.survey-btn-loading.survey-btn-loading {\n    color: transparent;\n    min-height: .8rem;\n    pointer-events: none;\n    position: relative;\n}\n\n.emotion-rating {\n    transition:\n        background-color 0.2s,\n        fill 0.2s,\n        opacity 0.5s;\n    cursor: pointer;\n    border-radius: 15px;\n    background-color: rgba(233, 235, 236, 1);\n    fill: rgba(18, 84, 113, 1);\n    width: 60px;\n    height: 60px;\n    padding: 3px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
